export interface TransactionListFilter {
  page?: number | null;
  count?: number | null;
  sort_key?: string | null;
  sort_by?: string | null;
  sender_id?: number[] | null;
  partner_id?: number[] | null;
  search?: string | null;
  current_status?: string[] | null;
  from_date?: string | null;
  to_date?: string | null;
}

export const defaultTransactionListFilter: TransactionListFilter = {
  page: 0,
  count: 10,
  sort_key: '',
  sort_by: '',
  sender_id: null,
  partner_id: null,
  search: '',
  current_status: null,
  from_date: '',
  to_date: '',
};
